import { connect } from 'react-redux';

import { expandSidebar, collapseSidebar, openLightbox } from '../actions';
import Sidebar from '../components/Sidebar';

const mapStateToProps = ({ browser, sidebar }) => ({
  appHeight: browser.height,
  isOpen: sidebar.isOpen,
  selectedTab: sidebar.selectedTab,
});

export default connect(mapStateToProps, { expandSidebar, collapseSidebar, openLightbox })(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/SidebarConnected.jsx